import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, withDefaults } from 'vue';
import type { TypographyType } from '../../types/Base/TypographyType';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTypography',
  props: {
    type: {},
    text: { default: '' },
    tag: { default: 'div' },
    color: {}
  },
  setup(__props: any) {

const props = __props;

const styles = computed(() => ({
    ...(props.color && {
        '--base-typography-color': props.color,
    }),
}));

const sizeClass = computed(() => `base-typography-${props.type}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), _mergeProps({
    type: _ctx.type,
    class: ["base-typography", sizeClass.value],
    style: styles.value
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.text), 1)
      ])
    ]),
    _: 3
  }, 16, ["type", "class", "style"]))
}
}

})